import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

export default function LoadingIndicator(props) {
  return <div style={{textAlign:"center"}}>
            <CircularProgress style={{marginTop: '60px'}} size={80} thickness={5} />
        </div>;
}



// WEBPACK FOOTER //
// ./src/components/shared/LoadingIndicator.js